<template><div><h1>VUX V2.1.1Rc.12 released</h1>
<h2><a href="/en/components/marquee.html">Marquee</a></h2>
<ul><li>[feature] Support async marquee-item</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[enhance] do not emit on-change is isCancel = true</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[enhance] Simpify Address data #1101</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[fix] Fix primary button active background-color</li>
</ul>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[enhance] trigger focus event of x-textarea when click counter</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.12 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.12-78.vue?514a76c9